/*!
 * Copyright Zendesk, Inc.
 * 
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0
 */
(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@zendeskgarden/react-theming");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"c-tooltip":"index__c-tooltip___WMDsn","c-arrow":"index__c-arrow___3WD9K","c-tooltip--extra-large":"index__c-tooltip--extra-large___qP957","c-tooltip--large":"index__c-tooltip--large___1Uvk6","c-tooltip--medium":"index__c-tooltip--medium___yU6Fh","c-tooltip__paragraph":"index__c-tooltip__paragraph___2g87i","c-tooltip__title":"index__c-tooltip__title___9DRRo","is-rtl":"index__is-rtl___3pWaV","c-tooltip--light":"index__c-tooltip--light___3HyTy"};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTheming = __webpack_require__(0);

var _cssArrows = __webpack_require__(14);

var _cssArrows2 = _interopRequireDefault(_cssArrows);

var _cssTooltips = __webpack_require__(2);

var _cssTooltips2 = _interopRequireDefault(_cssTooltips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * Copyright Zendesk, Inc.
                                                                                                                                                                                                                   *
                                                                                                                                                                                                                   * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                   * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                   */

var COMPONENT_ID = 'tooltip.tooltip';

var SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  EXTRA_LARGE: 'extra-large'
};

var PLACEMENT = {
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  RIGHT: 'right',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  BOTTOM: 'bottom',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  LEFT: 'left',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end'
};

var shouldShowArrow = function shouldShowArrow(_ref) {
  var arrow = _ref.arrow,
      placement = _ref.placement;

  return arrow && (placement === PLACEMENT.LEFT || placement === PLACEMENT.RIGHT || placement === PLACEMENT.BOTTOM || placement === PLACEMENT.BOTTOM_START || placement === PLACEMENT.BOTTOM_END || placement === PLACEMENT.TOP || placement === PLACEMENT.TOP_START || placement === PLACEMENT.TOP_END);
};

var retrieveTooltipMargin = function retrieveTooltipMargin(_ref2) {
  var arrow = _ref2.arrow,
      size = _ref2.size;

  if (arrow) {
    if (size === SIZE.LARGE) {
      return 'margin: 8px;';
    } else if (size === SIZE.EXTRA_LARGE) {
      return 'margin: 12px;';
    }
  }

  return 'margin: 6px';
};

/**
 * Accepts all `<div>` props
 */
var TooltipView = _styledComponents2.default.div.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "4.0.1",
  className: function className(props) {
    var _classNames;

    return (0, _classnames2.default)(_cssTooltips2.default['c-tooltip'], (_classNames = {}, _defineProperty(_classNames, _cssTooltips2.default['c-tooltip--medium'], props.size === SIZE.MEDIUM), _defineProperty(_classNames, _cssTooltips2.default['c-tooltip--large'], props.size === SIZE.LARGE), _defineProperty(_classNames, _cssTooltips2.default['c-tooltip--extra-large'], props.size === SIZE.EXTRA_LARGE), _defineProperty(_classNames, _cssTooltips2.default['c-arrow'], shouldShowArrow(props)), _defineProperty(_classNames, _cssArrows2.default['c-arrow'], shouldShowArrow(props)), _defineProperty(_classNames, _cssArrows2.default['c-arrow--r'], props.placement === PLACEMENT.LEFT), _defineProperty(_classNames, _cssArrows2.default['c-arrow--b'], props.placement === PLACEMENT.TOP), _defineProperty(_classNames, _cssArrows2.default['c-arrow--bl'], props.placement === PLACEMENT.TOP_START), _defineProperty(_classNames, _cssArrows2.default['c-arrow--br'], props.placement === PLACEMENT.TOP_END), _defineProperty(_classNames, _cssArrows2.default['c-arrow--l'], props.placement === PLACEMENT.RIGHT), _defineProperty(_classNames, _cssArrows2.default['c-arrow--t'], props.placement === PLACEMENT.BOTTOM), _defineProperty(_classNames, _cssArrows2.default['c-arrow--tl'], props.placement === PLACEMENT.BOTTOM_START), _defineProperty(_classNames, _cssArrows2.default['c-arrow--tr'], props.placement === PLACEMENT.BOTTOM_END), _defineProperty(_classNames, _cssTooltips2.default['is-rtl'], (0, _reactTheming.isRtl)(props)), _classNames));
  }
}).withConfig({
  displayName: 'TooltipView'
})(['', ';', ';'], function (props) {
  return retrieveTooltipMargin(props);
}, function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

TooltipView.propTypes = {
  arrow: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf([SIZE.SMALL, SIZE.MEDIUM, SIZE.LARGE, SIZE.EXTRA_LARGE]),
  /** All valid [Popper.JS Placements](https://popper.js.org/popper-documentation.html#Popper.placements) */
  placement: _propTypes2.default.oneOf([PLACEMENT.TOP, PLACEMENT.TOP_START, PLACEMENT.TOP_END, PLACEMENT.RIGHT, PLACEMENT.RIGHT_START, PLACEMENT.RIGHT_END, PLACEMENT.BOTTOM, PLACEMENT.BOTTOM_START, PLACEMENT.BOTTOM_END, PLACEMENT.LEFT, PLACEMENT.LEFT_START, PLACEMENT.LEFT_END])
};

TooltipView.defaultProps = {
  arrow: true,
  size: SIZE.SMALL
};

/** @component */
exports.default = TooltipView;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _cssTooltips = __webpack_require__(2);

var _cssTooltips2 = _interopRequireDefault(_cssTooltips);

var _reactTheming = __webpack_require__(0);

var _TooltipView = __webpack_require__(4);

var _TooltipView2 = _interopRequireDefault(_TooltipView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var COMPONENT_ID = 'tooltip.light_tooltip';

var SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  EXTRA_LARGE: 'extra-large'
};

var PLACEMENT = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right'
};

/**
 * Accepts all `<div>` props
 */
var LightTooltip = (0, _styledComponents2.default)(_TooltipView2.default).attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "4.0.1",
  className: (0, _classnames2.default)(_cssTooltips2.default['c-tooltip--light'])
}).withConfig({
  displayName: 'LightTooltip'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

LightTooltip.propTypes = {
  arrow: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf([SIZE.SMALL, SIZE.MEDIUM, SIZE.LARGE, SIZE.EXTRA_LARGE]),
  placement: _propTypes2.default.oneOf([PLACEMENT.RIGHT, PLACEMENT.LEFT, PLACEMENT.TOP, PLACEMENT.BOTTOM])
};

LightTooltip.defaultProps = {
  arrow: true,
  size: SIZE.LARGE
};

/** @component */
exports.default = LightTooltip;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getPopperPlacement = getPopperPlacement;
exports.getRtlPopperPlacement = getRtlPopperPlacement;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var SHARED_PLACEMENTS = {
  AUTO: 'auto',
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM: 'bottom',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end'
};

var GARDEN_PLACEMENTS = exports.GARDEN_PLACEMENTS = _extends({}, SHARED_PLACEMENTS, {
  END: 'end',
  END_TOP: 'end-top',
  END_BOTTOM: 'end-bottom',
  START: 'start',
  START_TOP: 'start-top',
  START_BOTTOM: 'start-bottom'
});

var POPPER_PLACEMENTS = exports.POPPER_PLACEMENTS = _extends({}, SHARED_PLACEMENTS, {
  RIGHT: 'right',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  LEFT: 'left',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end'
});

/**
 * Convert Garden RTL aware placement to Popper.JS valid placement
 * @param {String} gardenPlacement
 */
function getPopperPlacement(gardenPlacement) {
  var _extends2;

  var sharedPlacements = Object.values(SHARED_PLACEMENTS).reduce(function (acc, item) {
    acc[item] = item;

    return acc;
  }, {});

  var GARDEN_POPPER_MAPPINGS = _extends({}, sharedPlacements, (_extends2 = {}, _defineProperty(_extends2, GARDEN_PLACEMENTS.END, POPPER_PLACEMENTS.RIGHT), _defineProperty(_extends2, GARDEN_PLACEMENTS.END_TOP, POPPER_PLACEMENTS.RIGHT_START), _defineProperty(_extends2, GARDEN_PLACEMENTS.END_BOTTOM, POPPER_PLACEMENTS.RIGHT_END), _defineProperty(_extends2, GARDEN_PLACEMENTS.START, POPPER_PLACEMENTS.LEFT), _defineProperty(_extends2, GARDEN_PLACEMENTS.START_TOP, POPPER_PLACEMENTS.LEFT_START), _defineProperty(_extends2, GARDEN_PLACEMENTS.START_BOTTOM, POPPER_PLACEMENTS.LEFT_END), _extends2));

  return GARDEN_POPPER_MAPPINGS[gardenPlacement];
}

/**
 * Convert Garden RTL aware placement to RTL equivalent Popper.JS placement
 * @param {String} gardenPlacement
 */
function getRtlPopperPlacement(gardenPlacement) {
  var _RTL_PLACEMENT_MAPPIN;

  var RTL_PLACEMENT_MAPPINGS = (_RTL_PLACEMENT_MAPPIN = {}, _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.LEFT, POPPER_PLACEMENTS.RIGHT), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.LEFT_START, POPPER_PLACEMENTS.RIGHT_START), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.LEFT_END, POPPER_PLACEMENTS.RIGHT_END), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.TOP_START, POPPER_PLACEMENTS.TOP_END), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.TOP_END, POPPER_PLACEMENTS.TOP_START), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.RIGHT, POPPER_PLACEMENTS.LEFT), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.RIGHT_START, POPPER_PLACEMENTS.LEFT_START), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.RIGHT_END, POPPER_PLACEMENTS.LEFT_END), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.BOTTOM_START, POPPER_PLACEMENTS.BOTTOM_END), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.BOTTOM_END, POPPER_PLACEMENTS.BOTTOM_START), _RTL_PLACEMENT_MAPPIN);

  var popperPlacement = getPopperPlacement(gardenPlacement);

  return RTL_PLACEMENT_MAPPINGS[popperPlacement] || popperPlacement;
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactPopper = __webpack_require__(17);

var _reactPortal = __webpack_require__(16);

var _reactSelection = __webpack_require__(15);

var _reactTheming = __webpack_require__(0);

var _gardenPlacements = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright Zendesk, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * This container must provide a wrapper for the provided tooltip
 * due to constraints in our arrow css. We must ensure that the container
 * of the tooltip can retain it's relative positioning. Without this
 * container Popper would apply absolute positioning.
 */
var TooltipWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'TooltipContainer__TooltipWrapper'
})(['&[aria-hidden=\'true\']{display:none;}']);

/**
 * Due to Popper.JS needing a reference to a component we provide a simple wrapper
 * to ensure the correct reference is provided.
 */
var TriggerWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'TooltipContainer__TriggerWrapper'
})(['display:inline-block;']);

var TooltipContainer = function (_ControlledComponent) {
  _inherits(TooltipContainer, _ControlledComponent);

  function TooltipContainer() {
    var _ref;

    _classCallCheck(this, TooltipContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = TooltipContainer.__proto__ || Object.getPrototypeOf(TooltipContainer)).call.apply(_ref, [this].concat(args)));

    _this.openTooltip = function () {
      var delayMilliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.delayMilliseconds;

      clearTimeout(_this.closeTooltipTimeout);

      _this.openTooltipTimeout = setTimeout(function () {
        _this.setControlledState({ isVisible: true });
      }, delayMilliseconds);
    };

    _this.closeTooltip = function () {
      var delayMilliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.delayMilliseconds;

      clearTimeout(_this.openTooltipTimeout);

      _this.closeTooltipTimeout = setTimeout(function () {
        _this.setControlledState({ isVisible: false });
      }, delayMilliseconds);
    };

    _this.getTooltipId = function () {
      return _this.getControlledState().id + '--tooltip';
    };

    _this.getTriggerProps = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref2$tabIndex = _ref2.tabIndex,
          tabIndex = _ref2$tabIndex === undefined ? 0 : _ref2$tabIndex,
          onMouseEnter = _ref2.onMouseEnter,
          onMouseLeave = _ref2.onMouseLeave,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          other = _objectWithoutProperties(_ref2, ['tabIndex', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur']);

      return _extends({
        tabIndex: tabIndex,
        'aria-describedby': _this.getTooltipId(),
        onMouseEnter: (0, _reactSelection.composeEventHandlers)(onMouseEnter, function () {
          return _this.openTooltip();
        }),
        onMouseLeave: (0, _reactSelection.composeEventHandlers)(onMouseLeave, function () {
          return _this.closeTooltip();
        }),
        onFocus: (0, _reactSelection.composeEventHandlers)(onFocus, function () {
          return _this.openTooltip();
        }),
        // Close menu immediately when blurred
        onBlur: (0, _reactSelection.composeEventHandlers)(onBlur, function () {
          return _this.closeTooltip(0);
        })
      }, other);
    };

    _this.getTooltipProps = function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref3$id = _ref3.id,
          id = _ref3$id === undefined ? _this.getTooltipId() : _ref3$id,
          _ref3$role = _ref3.role,
          role = _ref3$role === undefined ? 'tooltip' : _ref3$role,
          onMouseEnter = _ref3.onMouseEnter,
          onMouseLeave = _ref3.onMouseLeave,
          other = _objectWithoutProperties(_ref3, ['id', 'role', 'onMouseEnter', 'onMouseLeave']);

      return _extends({
        id: id,
        role: role,
        onMouseEnter: (0, _reactSelection.composeEventHandlers)(onMouseEnter, function () {
          return _this.openTooltip();
        }),
        onMouseLeave: (0, _reactSelection.composeEventHandlers)(onMouseLeave, function () {
          return _this.closeTooltip();
        })
      }, other);
    };

    _this.convertGardenToPopperPlacement = function () {
      var placement = _this.props.placement;


      if ((0, _reactTheming.isRtl)(_this.props)) {
        return (0, _gardenPlacements.getRtlPopperPlacement)(placement);
      }

      return (0, _gardenPlacements.getPopperPlacement)(placement);
    };

    _this.state = {
      isVisible: false,
      id: _reactSelection.IdManager.generateId()
    };

    _this.mouseEntered = true;
    return _this;
  }

  _createClass(TooltipContainer, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.openTooltipTimeout);
      clearTimeout(this.closeTooltipTimeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          _props$render = _props.render,
          render = _props$render === undefined ? children : _props$render,
          trigger = _props.trigger,
          eventsEnabled = _props.eventsEnabled,
          popperModifiers = _props.popperModifiers,
          appendToBody = _props.appendToBody;

      var _getControlledState = this.getControlledState(),
          isVisible = _getControlledState.isVisible;

      return _react2.default.createElement(
        _reactPopper.Manager,
        { tag: false },
        _react2.default.createElement(
          _reactPopper.Target,
          null,
          function (_ref4) {
            var targetProps = _ref4.targetProps;

            return _react2.default.createElement(
              TriggerWrapper,
              { innerRef: targetProps.ref },
              trigger && trigger({
                getTriggerProps: function getTriggerProps(props) {
                  return _this2.getTriggerProps(_extends({}, props));
                },
                isVisible: isVisible
              })
            );
          }
        ),
        _react2.default.createElement(
          _reactPopper.Popper,
          {
            placement: this.convertGardenToPopperPlacement(),
            eventsEnabled: eventsEnabled,
            modifiers: popperModifiers
          },
          function (_ref5) {
            var popperProps = _ref5.popperProps,
                scheduleUpdate = _ref5.scheduleUpdate;

            var popperPlacement = popperProps['data-placement'];
            var outOfBoundaries = popperProps['data-x-out-of-boundaries'];

            var tooltip = _react2.default.createElement(
              TooltipWrapper,
              {
                innerRef: popperProps.ref,
                style: popperProps.style,
                'aria-hidden': !isVisible
              },
              render({
                getTooltipProps: function getTooltipProps(props) {
                  return _this2.getTooltipProps(props);
                },
                isVisible: isVisible,
                placement: popperPlacement,
                outOfBoundaries: outOfBoundaries,
                scheduleUpdate: scheduleUpdate
              })
            );

            if (appendToBody) {
              return _react2.default.createElement(
                _reactPortal.Portal,
                null,
                tooltip
              );
            }

            return tooltip;
          }
        )
      );
    }
  }]);

  return TooltipContainer;
}(_reactSelection.ControlledComponent);

TooltipContainer.propTypes = {
  /** Appends the tooltip to the body element */
  appendToBody: _propTypes2.default.bool,
  /**
   * @param {Object} renderProps
   * @param {Function} renderProps.getTooltipProps - Props to be spread onto the tooltip element
   * @param {Function} renderProps.isVisible - Whether the Tooltip is currently visible
   * @param {Any} renderProps.placement - The current placement of the Tooltip. Will update based on boundary conflicts.
   * @param {Any} renderProps.outOfBoundaries - Whether the current tooltip has escaped it's boundary.
   * @param {Any} renderProps.scheduleUpdate - Method to force an update within Popper.js
   */
  children: _propTypes2.default.func,
  /** Milliseconds of delay before open/close of tooltip is initiated */
  delayMilliseconds: _propTypes2.default.number,
  /** Whether Popper.js should update based on DOM resize events */
  eventsEnabled: _propTypes2.default.bool,
  /** The root ID to use for descendants. A unique ID is created if none is provided.  */
  id: _propTypes2.default.string,
  /** Controls visibility of tooltip */
  isVisible: _propTypes2.default.bool,
  /** Returns all changed state. Used for controlling usage. */
  onStateChange: _propTypes2.default.func,
  /**
   * These placements differ from the default naming of Popper.JS placements to help
   * assist with RTL layouts.
   **/
  placement: _propTypes2.default.oneOf(['auto', 'top', 'top-start', 'top-end', 'end', 'end-top', 'end-bottom', 'bottom', 'bottom-start', 'bottom-end', 'start', 'start-top', 'start-bottom']),
  /** Passes options to [Popper.JS Instance](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#new-popperreference-popper-options) */
  popperModifiers: _propTypes2.default.object,
  /** Identical to children */
  render: _propTypes2.default.func,
  /**
   * @param {Object} renderProps
   * @param {Function} renderProps.getTriggerProps - Props to be spread onto the trigger element
   * @param {Function} renderProps.isVisible - Whether the Tooltip is currently visible
   */
  trigger: _propTypes2.default.func
};
TooltipContainer.defaultProps = {
  placement: 'top',
  eventsEnabled: true,
  delayMilliseconds: 500
};
exports.default = (0, _reactTheming.withTheme)(TooltipContainer);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _cssTooltips = __webpack_require__(2);

var _cssTooltips2 = _interopRequireDefault(_cssTooltips);

var _reactTheming = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'tooltip.paragraph';

/**
 * Accepts all `<div>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var Paragraph = _styledComponents2.default.div.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "4.0.1",
  className: _cssTooltips2.default['c-tooltip__paragraph']
}).withConfig({
  displayName: 'Paragraph'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

/** @component */
exports.default = Paragraph;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _cssTooltips = __webpack_require__(2);

var _cssTooltips2 = _interopRequireDefault(_cssTooltips);

var _reactTheming = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'tooltip.title';

/**
 * Accepts all `<div>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var Title = _styledComponents2.default.div.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "4.0.1",
  className: _cssTooltips2.default['c-tooltip__title']
}).withConfig({
  displayName: 'Title'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

/** @component */
exports.default = Title;

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"c-arrow":"index__c-arrow___cuUSh","c-arrow--t":"index__c-arrow--t___1ZWKF","c-arrow--tl":"index__c-arrow--tl___322NF","c-arrow--tr":"index__c-arrow--tr___MeaCx","c-arrow--r":"index__c-arrow--r___1QMUz","c-arrow--rb":"index__c-arrow--rb___1HzLl","c-arrow--rt":"index__c-arrow--rt___1e89v","c-arrow--l":"index__c-arrow--l___1UW5e","c-arrow--lb":"index__c-arrow--lb___1femU","c-arrow--lt":"index__c-arrow--lt___uMq77","c-arrow--b":"index__c-arrow--b___31z-F","c-arrow--bl":"index__c-arrow--bl___Yjbqb","c-arrow--br":"index__c-arrow--br___2cmY-"};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("@zendeskgarden/react-selection");

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("react-portal");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = require("react-popper");

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TooltipContainer = __webpack_require__(8);

var _TooltipContainer2 = _interopRequireDefault(_TooltipContainer);

var _TooltipView = __webpack_require__(4);

var _TooltipView2 = _interopRequireDefault(_TooltipView);

var _LightTooltip = __webpack_require__(5);

var _LightTooltip2 = _interopRequireDefault(_LightTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright Zendesk, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  EXTRA_LARGE: 'extra-large'
};

var TYPE = {
  LIGHT: 'light',
  DARK: 'dark'
};

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    _classCallCheck(this, Tooltip);

    return _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).apply(this, arguments));
  }

  _createClass(Tooltip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appendToBody = _props.appendToBody,
          id = _props.id,
          _trigger = _props.trigger,
          defaultPlacement = _props.placement,
          eventsEnabled = _props.eventsEnabled,
          popperModifiers = _props.popperModifiers,
          delayMilliseconds = _props.delayMilliseconds,
          type = _props.type,
          arrow = _props.arrow,
          children = _props.children,
          size = _props.size,
          otherProps = _objectWithoutProperties(_props, ['appendToBody', 'id', 'trigger', 'placement', 'eventsEnabled', 'popperModifiers', 'delayMilliseconds', 'type', 'arrow', 'children', 'size']);

      return _react2.default.createElement(
        _TooltipContainer2.default,
        {
          appendToBody: appendToBody,
          id: id,
          placement: defaultPlacement,
          eventsEnabled: eventsEnabled,
          popperModifiers: popperModifiers,
          delayMilliseconds: delayMilliseconds,
          trigger: function trigger(_ref) {
            var getTriggerProps = _ref.getTriggerProps;

            return (0, _react.cloneElement)(_trigger, getTriggerProps(_trigger.props));
          }
        },
        function (_ref2) {
          var getTooltipProps = _ref2.getTooltipProps,
              placement = _ref2.placement;

          var tooltipProps = _extends({ arrow: arrow, placement: placement, size: size }, otherProps);
          var TooltipElem = type === TYPE.LIGHT ? _LightTooltip2.default : _TooltipView2.default;

          return _react2.default.createElement(
            TooltipElem,
            getTooltipProps(tooltipProps),
            children
          );
        }
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.propTypes = {
  /** Appends the tooltip to the body element */
  appendToBody: _propTypes2.default.bool,
  arrow: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  /** Milliseconds of delay before open/close of tooltip is initiated */
  delayMilliseconds: _propTypes2.default.number,
  /** Whether Popper.js should update based on DOM resize events */
  eventsEnabled: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  trigger: _propTypes2.default.node,
  /**
   * These placements differ from the default naming of Popper.JS placements to help
   * assist with RTL layouts.
   **/
  placement: _propTypes2.default.oneOf(['auto', 'top', 'top-start', 'top-end', 'end', 'end-top', 'end-bottom', 'bottom', 'bottom-start', 'bottom-end', 'start', 'start-top', 'start-bottom']),
  /** Passes options to [Popper.JS Instance](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#new-popperreference-popper-options) */
  popperModifiers: _propTypes2.default.object,
  size: _propTypes2.default.oneOf([SIZE.SMALL, SIZE.MEDIUM, SIZE.LARGE, SIZE.EXTRA_LARGE]),
  type: _propTypes2.default.oneOf([TYPE.LIGHT, TYPE.DARK])
};
Tooltip.defaultProps = {
  arrow: true,
  eventsEnabled: true,
  type: TYPE.DARK
};
exports.default = Tooltip;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tooltip = __webpack_require__(18);

Object.defineProperty(exports, 'Tooltip', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tooltip).default;
  }
});

var _TooltipContainer = __webpack_require__(8);

Object.defineProperty(exports, 'TooltipContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TooltipContainer).default;
  }
});

var _LightTooltip = __webpack_require__(5);

Object.defineProperty(exports, 'LightTooltip', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LightTooltip).default;
  }
});

var _TooltipView = __webpack_require__(4);

Object.defineProperty(exports, 'TooltipView', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TooltipView).default;
  }
});

var _Title = __webpack_require__(11);

Object.defineProperty(exports, 'Title', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Title).default;
  }
});

var _Paragraph = __webpack_require__(10);

Object.defineProperty(exports, 'Paragraph', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Paragraph).default;
  }
});

var _gardenPlacements = __webpack_require__(7);

Object.defineProperty(exports, 'GARDEN_PLACEMENTS', {
  enumerable: true,
  get: function get() {
    return _gardenPlacements.GARDEN_PLACEMENTS;
  }
});
Object.defineProperty(exports, 'POPPER_PLACEMENTS', {
  enumerable: true,
  get: function get() {
    return _gardenPlacements.POPPER_PLACEMENTS;
  }
});
Object.defineProperty(exports, 'getPopperPlacement', {
  enumerable: true,
  get: function get() {
    return _gardenPlacements.getPopperPlacement;
  }
});
Object.defineProperty(exports, 'getRtlPopperPlacement', {
  enumerable: true,
  get: function get() {
    return _gardenPlacements.getRtlPopperPlacement;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })
/******/ ])));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zendeskgarden/react-tooltips/dist/index.js
// module id = 1677
// module chunks = 7